module.exports = __webpack_public_path__ + "img/logo_sollicita_portal.db599f49.png";